import { render } from "./CadastroUsuarioAdm.vue?vue&type=template&id=1d97d2ab&scoped=true"
import script from "./CadastroUsuarioAdm.vue?vue&type=script&lang=js"
export * from "./CadastroUsuarioAdm.vue?vue&type=script&lang=js"

import "./CadastroUsuarioAdm.vue?vue&type=style&index=0&id=1d97d2ab&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d97d2ab"]])

export default __exports__